import { Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';

@Directive({
  selector: '[rtColorPickerText]',
  host: {
    '(input)': 'changeInput($event.target.value)',
  },
})
export class TextDirective {
  @Input('rtColorPickerText') public text: string | undefined;
  @Input('rg') public rg: number;

  @Output() public newValue: EventEmitter<{ v: number; rg: number }> = new EventEmitter();
  @Output() public newTextValue: EventEmitter<string> = new EventEmitter();

  public changeInput(value: string): void {
    if (this.rg === undefined) {
      this.newTextValue.emit(value);
    } else {
      const numeric = parseFloat(value);
      if (!isNaN(numeric) && numeric >= 0 && numeric <= this.rg) {
        this.newValue.emit({ v: numeric, rg: this.rg });
      }
    }
  }
}

@Directive({
  selector: '[rtColorPickerSlider]',
  host: {
    '(mousedown)': 'start($event)',
    '(touchstart)': 'start($event)',
  },
})
export class SliderDirective {
  @Input('rtColorPickerSlider') public slider: string | undefined;
  @Input('rgX') public rgX: number;
  @Input('rgY') public rgY: number;

  @Output() public newValue: EventEmitter<{
    v: number;
    s?: number;
    rg?: number;
    rgX?: number;
    rgY?: number;
  }> = new EventEmitter();

  private listenerMove: (event: MouseEvent) => void;
  private listenerStop: () => void;

  constructor(private el: ElementRef) {
    this.listenerMove = (event: MouseEvent) => {
      this.move(event);
    };
    this.listenerStop = () => {
      this.stop();
    };
  }

  public setCursor(event: MouseEvent): void {
    const height = this.el.nativeElement.offsetHeight;
    const width = this.el.nativeElement.offsetWidth;
    const x = Math.max(0, Math.min(this.getX(event), width));
    const y = Math.max(0, Math.min(this.getY(event), height));

    if (this.rgX !== undefined && this.rgY !== undefined) {
      this.newValue.emit({ s: x / width, v: 1 - y / height, rgX: this.rgX, rgY: this.rgY });
    } else if (this.rgX === undefined && this.rgY !== undefined) {
      // ready to use vertical sliders
      this.newValue.emit({ v: y / height, rg: this.rgY });
    } else {
      this.newValue.emit({ v: x / width, rg: this.rgX });
    }
  }

  public move(event: MouseEvent): void {
    event.preventDefault();
    this.setCursor(event);
  }

  public start(event: MouseEvent): void {
    this.setCursor(event);
    document.addEventListener('mousemove', this.listenerMove);
    document.addEventListener('touchmove', this.listenerMove);
    document.addEventListener('mouseup', this.listenerStop);
    document.addEventListener('touchend', this.listenerStop);
  }

  public stop(): void {
    document.removeEventListener('mousemove', this.listenerMove);
    document.removeEventListener('touchmove', this.listenerMove);
    document.removeEventListener('mouseup', this.listenerStop);
    document.removeEventListener('touchend', this.listenerStop);
  }

  public getX(event: TouchEvent | MouseEvent): number {
    return (
      // @ts-ignore
      (event.pageX !== undefined ? event.pageX : event.touches[0].pageX) -
      this.el.nativeElement.getBoundingClientRect().left -
      window.pageXOffset
    );
  }
  public getY(event: TouchEvent | MouseEvent): number {
    return (
      // @ts-ignore
      (event.pageY !== undefined ? event.pageY : event.touches[0].pageY) -
      this.el.nativeElement.getBoundingClientRect().top -
      window.pageYOffset
    );
  }
}

export class SliderPosition {
  constructor(public h: number, public s: number, public v: number, public a: number) {}
}

export class SliderDimension {
  constructor(public h: number, public s: number, public v: number, public a: number) {}
}
